// Commands: PART, JOIN, PRIVMSG, rpl_endofnames, rpl_topic, NOTICE, TOPIC, ACTION
export default class ChatAction {
  messageText() {
    if (this.command === 'JOIN') {
      return `${this.nick} has joined #TheCabin`
    } else if (this.command === 'PART' || this.command === 'QUIT') {
      return `${this.nick} has left #TheCabin`
    } else if (this.command === 'PRIVMSG') {
      return this.text
    } else if (this.command === 'TOPIC') {
      return `${this.nick} has changed the topic to ${this.args[1]}`
    } else if (this.command === 'HISTORY') {
      return this.text
    } else if (this.command === 'ACTION') {
      return `* ${this.nick} ${this.text}`
    } else if (this.command === 'NICK') {
      return `${this.nick} has changed thier nickname to ${this.args[0]}`
    } else if (this.command === 'KICK') {
      return `${this.nick} has removed ${this.args[1]} from #TheCabin: ${this.args[2]}`
    }
  }

  avatar() {}

  fromCommand(command) {
    // console.log(command)
    this.timestamp = command.timestamp || new Date()
    this.command = command.command
    this.rawCommand = command.rawCommand
    this.commandType = command.commandType
    this.nick = command.nick
    this.user = command.user
    this.host = command.host
    this.args = command.args
    this.text = command.args[1]
    this.isMe = command.isMe
    this.id = this.timestamp.getTime()

    if (command.command === 'NICK') {
      this.target = command.target
    } else {
      this.target = command.args[0]
    }

    if (this.text && command.command === 'PRIVMSG' && this.text.length >= 7 && this.text.substring(0, 7) === '\u0001ACTION') {
      this.command = 'ACTION'
      this.text = this.text.substring(8)
      this.ctcp = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/ChatAction.js